import React from 'react';
import { graphql } from 'gatsby';
import { PageContextType } from '../types';
import { PageMetadata } from '../components/PageMetadata';
import { Slices, SliceFragments } from '../components/Slices';
import { LinkFragments, MetaFragment } from './fragments.gql';
import { PageDataType } from './types';
import { getUnpublishedPageData } from './pageData';

type PageTemplateProps = {
    location: Location;
    pageContext: PageContextType;
    data?: {
        prismic: {
            page?: PageDataType;
        };
    };
};

export const PageTemplate: React.FC<PageTemplateProps> = ({ data, pageContext, location }) => {
    const page = (data && data.prismic.page) || getUnpublishedPageData(location);

    return (
        <>
            <PageMetadata page={page} pageContext={pageContext} />
            <Slices location={location} pageContext={pageContext} slices={page.body} />
        </>
    );
};

// NOTE: This variable must ALWAYS remain named `query` or Prismic previews will break
export const query = graphql`
    query($uid: String!, $lang: String!) {
        prismic {
            page(uid: $uid, lang: $lang) {
                ...MetaFragment
                title
                meta_title
                meta_description
                meta_canonical {
                    ...LinkFragment
                }
                meta_image
                meta_twitter_image
                body {
                    ...PrismicBlogFragment
                    ...PrismicCallToActionFragment
                    ...PrismicFaqFragment
                    ...PrismicFeaturedArtistsFragment
                    ...PrismicFeatureFragment
                    ...PrismicHeroFragment
                    ...PrismicLinkListFragment
                    ...PrismicLogoListFragment
                    ...PrismicMasteringDemosFragment
                    ...PrismicPressListFragment
                    ...PrismicPricingFragment
                    ...PrismicQuotesFragment
                    ...PrismicQuotesVideoFragment
                    ...PrismicSignupFragment
                    ...PrismicTextBlockFragment
                    ...PrismicTextGridFragment
                    ...PrismicVideoPlayerFragment
                    ...PrismicVisualFragment
                }
                home_page
                show_navigation_header
                header_type
                partner_logo
                partner_url {
                    ...LinkFragment
                }
                show_footer
                theme
            }
        }
    }
`;

// We must manually add `fragments` property to the component for Prismic previews to work
// @ts-ignore
PageTemplate.fragments = [LinkFragments, MetaFragment, ...SliceFragments];
// @ts-ignore
PageTemplate.query = query;

export default PageTemplate;
